import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        title: "Pesanan berhasil diterima!",
        message: "Download, cek, dan segera proses pesanan customer Anda.",
        image: "ill_badge_success",
        textSuccess: "Download Pesanan",
        textCancel: "Kembali",
        class: "px-8",
        customWidth: "417px",
        customWrapperButton: "flex justify-center",
        customParentButton: "w-1/2",
        customButton: "w-full",
        onClose: _ctx.onCloseModal,
        onSubmit: _ctx.onSubmitModal,
        idButtonSubmit: "button_download_order_modal_success_accept_order",
        idButtonCancel: "button_back_modal_success_accept_order"
      }, null, 8, ["onClose", "onSubmit"]))
    : _createCommentVNode("", true)
}